import React, {forwardRef} from 'react'
import {Block, Row} from 'jsxstyle'
import {ReactComponent as SightcallLogo} from '../../common/assets/sightcall-logo.svg'
import {useCopilotContext} from './CopilotContext'
import ConversationList from './CopilotConversationList'
import ChatView from './CopilotChatView'
import i18n from '../../common/i18n'

interface ChatPopupProps {
  onClose: () => void
}

const ChatPopup = forwardRef<HTMLDivElement, ChatPopupProps>(({onClose}, ref) => {
  const {selectedConversation} = useCopilotContext()

  return (
    <Block
      props={{ref}}
      position="fixed"
      bottom="90px"
      right="80px"
      width="400px"
      height="550px"
      backgroundColor="#fff"
      borderRadius="10px"
      boxShadow="0 4px 20px rgba(0, 0, 0, 0.15)"
      zIndex={1000}
      overflow="hidden"
      display="flex"
      flexDirection="column"
    >
      <Row backgroundColor="#000000" height="60px" padding="0 20px" alignItems="center" justifyContent="space-between">
        <Row alignItems="center" gap="10px">
          <SightcallLogo width={24} height={11} color="#FFFFFF" />
          <Block fontSize="16px" fontWeight={500} color="#fff">
            {i18n.t('xk.copilot.title')}
          </Block>
        </Row>
        <Block
          cursor="pointer"
          props={{
            onClick: onClose,
          }}
          fontSize="18px"
          color="#fff"
        >
          ✕
        </Block>
      </Row>

      {!selectedConversation ? <ConversationList /> : <ChatView />}
    </Block>
  )
})

export default ChatPopup
